var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.opened
    ? _c("div", { staticClass: "modal-mask" }, [
        _c("div", { staticClass: "modal-wrapper" }, [
          _c("div", { staticClass: "modal-dialog modal-dialog-scrollable" }, [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c("h5", { staticClass: "modal-title" }, [
                  _vm._v("Change Project Lifecycle to Scheduled"),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "close",
                    attrs: { type: "button" },
                    on: { click: _vm.close },
                  },
                  [_vm._v("×")]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body" }, [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", [_vm._v("Start date:")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "input-group" }, [
                      _c("input", {
                        staticClass: "form-control pointer bg-white",
                        attrs: {
                          placeholder: "Select a start date",
                          type: "text",
                          readonly: "",
                        },
                        domProps: { value: _vm.startDateLabel },
                        on: {
                          click: function ($event) {
                            _vm.isStartDateMonthPickerVisible =
                              !_vm.isStartDateMonthPickerVisible
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "input-group-append" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-outline-secondary",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                _vm.isStartDateMonthPickerVisible =
                                  !_vm.isStartDateMonthPickerVisible
                              },
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "fa-regular fa-calendar",
                              attrs: { "aria-hidden": "true" },
                            }),
                          ]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    !_vm.isStartDateSet || !_vm.isStartDateValid
                      ? _c("p", { staticClass: "text-danger" }, [
                          _vm._v(
                            "\n                            A start date is required and cannot be in the past.\n                        "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("month-picker", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isStartDateMonthPickerVisible,
                          expression: "isStartDateMonthPickerVisible",
                        },
                      ],
                      attrs: {
                        "min-date": _vm.vm.minStartDate,
                        "max-date": _vm.vm.maxStartDate,
                        "default-month": _vm.vm.defaultMonth,
                        "default-year": _vm.vm.defaultYear,
                      },
                      on: { change: _vm.onStartDateChange },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-secondary",
                    attrs: { type: "button" },
                    on: { click: _vm.close },
                  },
                  [_vm._v("Cancel")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    attrs: {
                      type: "button",
                      disabled: !_vm.isStartDateSet || !_vm.isStartDateValid,
                    },
                    on: { click: _vm.confirm },
                  },
                  [_vm._v("Confirm")]
                ),
              ]),
            ]),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", [
      _vm._v(
        "\n                        You are about to change the project lifecycle to the "
      ),
      _c("strong", [_vm._v("Scheduled")]),
      _vm._v(
        " stage.\n                        Please ensure the start date is set and valid.\n                    "
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }